// extracted by mini-css-extract-plugin
export default {"accounts_list__item":"style_accounts_list__item__8nqxb","accounts_list_item__info_text":"style_accounts_list_item__info_text__6Dkhn"};